module.exports = __webpack_public_path__ + "7f198129.png";


//////////////////
// WEBPACK FOOTER
// ./public/images/ic_medico_online.png
// module id = 1290
// module chunks = 0 1